(function () {
  // Chargé une seule fois ; Dawn remplace le HTML du panier à chaque modification,
  // donc on surveille l'arrivée des nouvelles barres pour les initialiser.
  if (window.CPB) return;

  var lastPct = 0;
  var lastInit = 0;
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;

  function formatMoney(root, cents) {
    var fmt = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
    var parts = (cents / 100).toFixed(2).split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withDot;
    });
  }

  // Position de la barre : remplissage proportionnel entre chaque palier
  // (les icônes sont espacées régulièrement, pas selon leur montant)
  function percentFor(root, total) {
    var points = [{ t: 0, p: 0 }];
    root.querySelectorAll('.cpb-step').forEach(function (s) {
      points.push({ t: parseInt(s.dataset.threshold, 10) * rate, p: parseFloat(s.dataset.pos) });
    });
    points.sort(function (a, b) { return a.t - b.t; });
    var last = points[points.length - 1];
    if (total >= last.t) return 100;
    for (var i = 1; i < points.length; i++) {
      if (total < points[i].t) {
        var a = points[i - 1], b = points[i];
        return a.p + ((total - a.t) / (b.t - a.t)) * (b.p - a.p);
      }
    }
    return 100;
  }

  function render(root, total) {
    var pct = Math.max(0, Math.min(100, percentFor(root, total)));
    var fill = root.querySelector('.cpb-fill');
    var cursor = root.querySelector('.cpb-cursor');
    var msgEl = root.querySelector('.cpb-message');

    fill.style.width = pct + '%';
    if (cursor) {
      cursor.style.left = pct + '%';
      cursor.classList.toggle('is-hidden', total <= 0 || pct >= 100);
      cursor.querySelector('.cpb-bubble').textContent = formatMoney(root, total);
    }

    var next = null;
    root.querySelectorAll('.cpb-step').forEach(function (s) {
      var t = parseInt(s.dataset.threshold, 10) * rate;
      var reached = total >= t;
      s.classList.toggle('is-reached', reached);
      if (!reached && (!next || t < next.t)) next = { t: t, label: s.dataset.label };
    });

    msgEl.innerHTML = next
      ? root.dataset.msg
          .replace('[montant]', '<strong>' + formatMoney(root, next.t - total) + '</strong>')
          .replace('[palier]', '<strong>' + next.label + '</strong>')
      : root.dataset.msgDone;

    lastPct = pct;
  }

  function init(root) {
    if (root.dataset.cpbInit) return;
    root.dataset.cpbInit = '1';
    lastInit = Date.now();
    var total = parseInt(root.dataset.total, 10);
    var fill = root.querySelector('.cpb-fill');
    var cursor = root.querySelector('.cpb-cursor');

    // Place la barre à la position précédente (0 au premier affichage) sans animation...
    fill.style.transition = 'none';
    fill.style.width = lastPct + '%';
    if (cursor) { cursor.style.transition = 'none'; cursor.style.left = lastPct + '%'; }
    void fill.offsetWidth;
    fill.style.transition = '';
    if (cursor) cursor.style.transition = '';

    // ...puis la fait glisser jusqu'au montant actuel du panier
    requestAnimationFrame(function () { render(root, total); });
  }

  function scan() {
    document.querySelectorAll('.cpb').forEach(init);
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cpb').forEach(function (root) { render(root, cart.total_price); });
      })
      .catch(function () {});
  }

  window.CPB = { scan: scan, refresh: refresh };

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });

    // À chaque ouverture du panier à droite, la barre se remplit à nouveau depuis 0
    // (sauf juste après un ajout au panier, où elle glisse déjà depuis l'ancien montant)
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var wasOpen = drawer.classList.contains('active');
      new MutationObserver(function () {
        var isOpen = drawer.classList.contains('active');
        if (isOpen && !wasOpen && Date.now() - lastInit > 800) {
          lastPct = 0;
          drawer.querySelectorAll('.cpb').forEach(function (root) {
            delete root.dataset.cpbInit;
            init(root);
          });
        }
        wasOpen = isOpen;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Événement natif de Dawn quand le panier change
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
